import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MediaPipelineInfo, MediaProcessInfo, standardGetHttpOptions, standardHttpOptions } from '@models';
import { LoadingService } from '@services/loading.service';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { KigSettings, KIG_SETTINGS } from '../../../settings/kig-settings';
import { UserService } from '@services/user.service';
import {  catchError, finalize, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { ScoutviewImage } from '@models/Scoutview/scoutview.model';
import { SvMetadataInfo } from '@models/Scoutview/scoutviewInfo.model';


@Injectable()
export class MediaPipelineService {
  public standardHttpOptionsWithUser: any;

  private apiUrl: string;

  constructor(private http: HttpClient,
              private loadingService: LoadingService,
              @Inject(KIG_SETTINGS) private settings: KigSettings,
              private userService: UserService) {
    this.apiUrl = this.settings.apiUrl;
  }

  buildStandardHttpOptionsWithUser(username: string) {
    this.standardHttpOptionsWithUser = {
      withCredentials: true,
      headers: new HttpHeaders({
        ['Content-Type']: 'application/json',
        username
      })
    };
  }


  public getMediaProcesses(): Observable<MediaProcessInfo[]> {
    this.loadingService.setMessage('Getting available pipeline processes ...');
    return this.http.get<MediaProcessInfo[]>(`${ this.apiUrl }/mediaPipeline/mediaprocesses`, standardGetHttpOptions).pipe(
      catchError(this.handleError),
      finalize(() => this.loadingService.clearMessage())
    );
  }


  public searchMediaPipelines(sourceSerials: string[]): Observable<MediaPipelineInfo[]> {
    return this.http.post<MediaPipelineInfo[]>(`${ this.apiUrl }/mediaPipeline/searchPipelines`, JSON.stringify(sourceSerials), standardHttpOptions).pipe(
      catchError(this.handleError)
    );
  }


  public createOrUpdateMediaPipeline(mediaPipelineInfo: MediaPipelineInfo): Observable<string> {
    return this.http.post<string>(`${ this.apiUrl }/mediaPipeline/updatePipeline`, JSON.stringify(mediaPipelineInfo), standardHttpOptions).pipe(
      catchError(this.handleError)
    );
  }

  
  public deleteMediaPipeline(mediaPipelineId: number): Observable<any> {
    return this.http.delete(`${ this.apiUrl }/mediaPipeline/${ mediaPipelineId }`, standardHttpOptions).pipe(
      catchError(this.handleError)
    );
  }


  public applyPipelineToMedia(pipelineId: number, svMetaDataId: number): Observable<any> {
    this.loadingService.setMessage('Running pipeline ...');
    return this.http.get<any>(`${ this.apiUrl }/mediaPipeline/runpipeline/${ pipelineId }/${ svMetaDataId }`, standardGetHttpOptions).pipe(
      catchError(this.handleError),
      finalize(() => this.loadingService.clearMessage())
    );
  }


  private handleError(error: any) {
    if (error.status === 404) {
      return of(null);
    }
    return throwError(() => error);
  }
}
